import React from 'react';
import DocContent from './DocContent';
import { blocks } from '../content/ChapterHandbookContent';

export default function ChapterHandbook() {
  return <DocContent blocks={blocks} />;
}
